<template>
  <div class="mc-insights">
    <div class="mc-insights__top">
      <div class="mc-insights__ico">
        <feather-icon
          icon="TrendingUpIcon"
          size="20"
        />
      </div>
      <h3 class="mc-insights__title">
        Insights do Período
      </h3>
    </div>
    <ul class="mc-insights__list">
      <li
        v-for="(item, i) in items"
        :key="i"
      >
        {{ item }}
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'InsightsPeriodoBot',
  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },
}
</script>

<style scoped>
.mc-insights {
  background: var(--mc-surface);
  border-radius: var(--mc-radius-lg);
  border: 1px solid var(--mc-border);
  box-shadow: var(--mc-shadow-md);
  padding: 1.35rem 1.4rem;
  margin-bottom: 1.25rem;
  transition: transform 0.22s ease, box-shadow 0.22s ease;
}

.mc-insights:hover {
  transform: translateY(-2px);
  box-shadow: 0 16px 34px rgba(93, 42, 140, 0.1);
}

.mc-insights__top {
  display: flex;
  align-items: center;
  gap: 0.65rem;
  margin-bottom: 1rem;
}

.mc-insights__ico {
  width: 40px;
  height: 40px;
  border-radius: 12px;
  background: linear-gradient(135deg, rgba(157, 78, 221, 0.14) 0%, rgba(228, 106, 169, 0.12) 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--mc-purple) !important;
}

.mc-insights__title {
  font-family: 'Plus Jakarta Sans', 'Inter', sans-serif;
  font-size: 1.05rem;
  font-weight: 800;
  color: var(--mc-text);
  margin: 0;
}

.mc-insights__list {
  margin: 0;
  padding: 0 0 0 1.15rem;
  font-size: 0.92rem;
  font-weight: 500;
  color: var(--mc-purple);
  line-height: 1.55;
}

.mc-insights__list li {
  margin-bottom: 0.55rem;
}

.mc-insights__list li:last-child {
  margin-bottom: 0;
}
</style>
